import { ReactNode } from 'react';

import { Trigger as RadixTrigger, TabsTriggerProps } from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';

import { Text } from '../../../Text';

interface BillingTriggerProps extends TabsTriggerProps {
  readonly title: string;
  readonly subtitle: ReactNode;
  readonly value: string;
  readonly disabled?: boolean;
  readonly children?: ReactNode;
}

function BillingTrigger({ disabled, title, subtitle, value, children, className, ...props }: BillingTriggerProps) {
  return (
    <RadixTrigger
      value={value}
      disabled={disabled}
      className={twMerge(
        'focus-ring relative rounded-xl border border-white bg-white p-4 hover:bg-light-blue-50',
        'transition duration-300',
        'text-center text-blue-500',
        'radix-disabled:bg-neutral-300 radix-disabled:text-neutral-500',
        'radix-state-active:border-blue-500 radix-state-active:bg-light-blue-100',
        'radix-state-active:radix-disabled:bg-light-blue-100',
        className,
      )}
      {...props}
    >
      {children}
      <Text weight="bold" variant="title-1" className="h-8">
        {title}
      </Text>
      <Text variant="caption-1" className="h-8 whitespace-pre-wrap">
        {subtitle}
      </Text>
    </RadixTrigger>
  );
}

export { BillingTrigger as Trigger };
